import {
  SAColumns,
  SAIcon,
  SAIcons,
  SAInput,
  SAText,
} from "@saux/design-system-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import CheckBox from "../checkBox/CheckBox";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { createOrUpdateAdjusterSchedule } from "../../store/actions/userActions";
import {
  PROFILE_UPDATED_SUCCESS,
  SCHEDULE_TIME_ERROR,
  SNACKBAR,
} from "../../utils/constants";


export default function MyInformation(props: any) {
  const user = useSelector((state: any) => state.user);
  const userInfo = {
    ...user.profileInfo,
  };
  const dispatch = useDispatch();

  const getActiveDays = () => {
    let activeDays: any = [];
    Object.entries(userInfo.workingDays).forEach((day) => {
      let [key, value] = day;
      if (value) {
        activeDays.push(key);
      }
    });
    return activeDays;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (userInfo.startTime > userInfo.endTime) {
      dispatch(
        snackbarOpen({
          open: true,
          message: SCHEDULE_TIME_ERROR,
          type: SNACKBAR.ERROR,
        })
      );
      return;
    } else {
      let adjusterInput = {
        adjusterEmailId: userInfo.adjusterEmailId,
        adjusterId: userInfo.adjusterEmailId,
        adjusterName: userInfo.adjusterName,
        phoneNumber: userInfo.phoneNumber,
        days: getActiveDays(),
        startTime: userInfo.startTime,
        endTime: userInfo.endTime,
        timeZone: new Date().getTimezoneOffset(),
      };
      dispatch(
        createOrUpdateAdjusterSchedule(adjusterInput, (res: any) => {
          dispatch(
            snackbarOpen({
              open: true,
              message: PROFILE_UPDATED_SUCCESS,
              type: SNACKBAR.SUCCESS,
            })
          );
        })
      );
    }
  };

  return (
    <>
      <div role="form" className="profile-details">
        <SAInput
          id="name"
          data-testid="name"
          name="adjusterName"
          label="Name"
          type="text"
          disabled={true}
          value={userInfo.adjusterName}
          required={true}
        />
        <SAColumns>
          <SAInput
            id="email"
            name="adjusterEmailId"
            label="Email Address"
            type="email"
            data-testid="email"
            required={true}
            disabled={true}
            value={userInfo.adjusterEmailId}
          />
          <SAInput
            id="phoneNumber"
            name="phoneNumber"
            label="Phone Number"
            type="tel"
            data-testid="phone-number"
            required={true}
            disabled={true}
            value={userInfo.workPhoneNumber}
            placeholder={"123-456-7890"}
            pattern={"[0-9]{3}-[0-9]{3}-[0-9]{4}"}
          />
        </SAColumns>
        <div style={{ marginBottom: 20, fontWeight: "normal" }}>
          My Schedule
        </div>
        <div className="week-days">
          <SAColumns
            spacing={{
              xs: "xxs",
              sm: "xxs",
              md: "xxs",
              lg: "xxs",
              xl: "xxs",
            }}
          >
            <CheckBox
              id="sun"
              name="sun"
              label={"Sun"}
              isChecked={userInfo.sundayAvailable}
              disabled={true}
            />
            <CheckBox
              id="mon"
              name="mon"
              label={"Mon"}
              isChecked={userInfo.mondayAvailable}
              disabled={true}
            />
            <CheckBox
              id="tue"
              name="tue"
              label={"Tue"}
              isChecked={userInfo.tuesdayAvailable}
              disabled={true}
            />
            <CheckBox
              id="wed"
              name="wed"
              label={"Wed"}
              isChecked={userInfo.wednesdayAvailable}
              disabled={true}
            />
            <CheckBox
              id="thu"
              name="thu"
              label={"Thu"}
              isChecked={userInfo.thursdayAvailable}
              disabled={true}
            />
            <CheckBox
              id="fri"
              name="fri"
              label={"Fri"}
              isChecked={userInfo.fridayAvailable}
              disabled={true}
            />
            <CheckBox
              id="sat"
              name="sat"
              label={"Sat"}
              isChecked={userInfo.saturdayAvailable}
              disabled={true}
            />
          </SAColumns>
        </div>
        <SAColumns columns={[4, 4, 4]} spacing={{ lg: "xs", xl: "xs" }}>
          <SAInput
            id="startTime"
            name="startTime"
            label="Start Time"
            type="text"
            value={userInfo.startTime}
            disabled
            required={true}
          />
          <SAInput
            id="endTime"
            name="endTime"
            label="End Time"
            type="text"
            required={true}
            value={userInfo.endTime}
            disabled
          />
          <SAInput
            id="endTime"
            name="endTime"
            label="Time Zone"
            type="text"
            required={true}
            disabled
            value={userInfo.timeZone}
          />
        </SAColumns>
      </div>
    </>
  );
}
